module.exports = __webpack_public_path__ + "static/img/shushiClick.8da988f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shushiClick.png
// module id = Ela+
// module chunks = 0